import React, { useCallback } from 'react';
import { PromptConfirmationModal } from 'ui';
import { AdministrationMessagesTranslation } from '../constants';

interface DeleteMessageMenuProps {
  id: number;
  onDelete: (id: number, successMessage: string) => void;
  disabled: boolean;
  translation: AdministrationMessagesTranslation;
}

export const DeleteMessageMenu: React.FC<DeleteMessageMenuProps> = ({
  id, onDelete, disabled, translation
}) => {

  const onClick = useCallback(
    () => {
      !!id && onDelete(id, translation.message_deleted);
    },
    [id]
  );

  return <PromptConfirmationModal
    title={translation.delete_message}
    description={translation.delete_message_confirm}
    continueText={translation.delete_message}
    cancelText={translation.cancel}
    onContinue={onClick}>
    <button type="button" className="dropdown-item" disabled={disabled}>
      {translation.delete_message}
    </button>
  </PromptConfirmationModal>;
};
